module.exports = __webpack_public_path__ + "img/img12.37e4302b.jpg";